<ng-container *ngIf="{ loading: loading$ | async, heading: heading$ | async } as obs">
  @if (obs.loading || obs.heading === null) {
    <div class="heading skeleton"></div>
  }

  @if (!obs.loading && obs.heading) {
    <h1 class="text-h5-s text-xs-h5-s text-md-h5-m text-lg-h4-m text-xl-h3-m heading">{{ obs.heading }}</h1>
  }
</ng-container>
